function roundUp(num, precision) {
  precision = Math.pow(10, precision);
  return Math.ceil(num * precision) / precision;
}

function numberFormat(number, decimals, dec_point, thousands_sep) { // Format a number with grouped thousands
  var i, j, kw, kd, km;

  // input sanitation & defaults
  if (isNaN(decimals = Math.abs(decimals))) {
      decimals = 2;
  }
  if (dec_point == undefined) {
      dec_point = ",";
  }
  if (thousands_sep == undefined) {
      thousands_sep = ".";
  }

  i = parseInt(number = (+number || 0).toFixed(decimals)) + "";

  if ((j = i.length) > 3) {
      j = j % 3;
  } else {
      j = 0;
  }

  km = (j ? i.substr(0, j) + thousands_sep : "");
  kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
  kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");

  return km + kw + kd;
}

$(document).ready(function() {

  var currentPrice = function() {
      var priceAttr = $('.purchase-details .price .money').attr('data-price');
      if (priceAttr) {
          return parseFloat(priceAttr);
      }
      return parseFloat($('.purchase-details .price .money').text().split(' ')[1]);
  }

  var currentComparePrice = function() {
      var comparePriceAttr = $('.purchase-details .compare-at-price .money').attr('data-price');
      if (comparePriceAttr) {
          return parseFloat(comparePriceAttr);
      }
      return parseFloat($('.purchase-details .compare-at-price .money').text().split(' ')[1]);
  }

  var updateSalePercentage = function() {
      var price = currentPrice();
      var comparePrice = currentComparePrice();
      var salePercentageEl = $('.purchase-details [data-sale-percentage]');

      if (comparePrice && comparePrice > price && !isNaN(comparePrice) && !isNaN(price)) {
          var priceDifference = comparePrice - price;
          var salePercentage = Math.round((priceDifference / comparePrice) * 100);
          salePercentageEl.text('-' + salePercentage + '%').show();
      } else {
          salePercentageEl.hide();
      }
  }

  var originalPrice = productPrice;
  var originalComparePrice = productComparePrice > 0 ? productComparePrice : null;

  var currentQuantity = function() {
      return $(".quantityPrice .quantity-input").val();
  }
  var previousQuantity = 1;

  var inventory = JSON.parse($('[data-product-form]').attr('data-variant-inventory').replace('[', '').replace(']', ''));

  // Initialize sale percentage on page load
  setTimeout(function() {
      updateSalePercentage();
  }, 500);

  /* Consider deleting, doesn't seem to be in use anymore */
  var stangenLange = $("#osen_or_schlauf_info").find("input#length_bar").prop('disabled');
  var schienLange = $("#click_or_wave_info").find("input#length").prop('disabled');
  var schienLangeWave = $("#wave_info").find("input#length_wave").prop('disabled');

  $('.color-swatches .swatch.opener').on('click', function() {
      $('.color-swatches .swatch').show();
      $('.color-swatches .swatch.opener').hide();
  });

  $("#clic_info").hide();
  $("#click_or_wave_info").hide();
  $("#wave_info").hide();
  $("#osen_info").hide();
  $("#osen_or_schlauf_info").hide();
  $("#Gleiter_info").hide();
  

  $("#clic_info").find("input[name='minMax']").prop("disabled", true);
  $("#click_or_wave_info").find("input[name='length']").prop("disabled", true);
  $("#wave_info").find("input[name='length']").prop("disabled", true);
  $("#osen_or_schlauf_info").find("input[name='length_bar']").prop("disabled", true);
  $("#osen_info").find("input#osen_val_1").prop("disabled", true);
  $("#osen_info").find("input#osen_val_2_5").prop("disabled", true);
  $("#osen_info").find("input#osen_val_4").prop("disabled", true);
  $("#Gleiter_info").find("input#halbverdeckter").prop("disabled", true);


    /* Clic */
    $('input[name="accesories"]').click(function() {
      if ($(this).attr("value") == '90') {
          $("#clic_info").show();
          $("#click_or_wave_info").show();
          $("#wave_info").hide();
          $("#osen_info").hide();
          $("#osen_or_schlauf_info").hide();
          $("#Gleiter_info").show();
          $('#length_bar').val('');
          $('#length_wave').val('');


          $("#clic_info").find("input[name='minMax']").prop("disabled", false);
          $("#click_or_wave_info").find("input[name='length']").prop("disabled", false);
          $("#wave_info").find("select[name='length_wave']").prop("disabled", true);
          $("#osen_info").find("input#osen_val_1").prop("checked", false);
          $("#osen_info").find("input#osen_val_2_5").prop("checked", false);
          $("#osen_info").find("input#osen_val_4").prop("checked", false);
          $("#osen_info").find("input#osen_val_1").prop("disabled", true);
          $("#osen_info").find("input#osen_val_2_5").prop("disabled", true);
          $("#osen_info").find("input#osen_val_4").prop("disabled", true);
          $("#osen_or_schlauf_info").find("input[name='length_bar']").prop("disabled", true);
          $("#Gleiter_info").find("input#halbverdeckter").prop("disabled", false);

    /* Ösen */
    } else if ($(this).attr("value") == '150') {
          $("#osen_info").show();
          $("#clic_info").hide();
          $("#click_or_wave_info").hide();
          $("#wave_info").hide();
          $("#osen_or_schlauf_info").show();
          $('#length').val('');
          $('#length_wave').val('');
          $("#Gleiter_info").hide();
          $("#osen_info").find("input#osen_val_1").prop("disabled", false);
          $("#osen_info").find("input#osen_val_2_5").prop("disabled", false);
          $("#osen_info").find("input#osen_val_4").prop("disabled", false);

          $("#clic_info").find("input[name='minMax']").prop("disabled", true);
          $("#click_or_wave_info").find("input[name='length']").prop("disabled", true);
          $("#wave_info").find("select[name='length_wave']").prop("disabled", true);
          $("#osen_or_schlauf_info").find("input[name='length_bar']").prop("disabled", false);
          $("#Gleiter_info").find("input#halbverdeckter").prop("disabled", true);


    /* Wave */
    } else if ($(this).attr("value") == '85') {
          $("#osen_info").hide();
          $("#clic_info").show();
          $("#click_or_wave_info").hide();
          $("#wave_info").show();
          $("#osen_or_schlauf_info").hide();
          $('#length_bar').val('');
          $('#length').val('');
          $("#Gleiter_info").hide();

          $("#clic_info").find("input[name='minMax']").prop("disabled", false);
          $("#click_or_wave_info").find("input[name='length']").prop("disabled", true);
          $("#wave_info").find("select[name='length_wave']").prop("disabled", false);
          $("#osen_info").find("input#osen_val_1").prop("checked", false);
          $("#osen_info").find("input#osen_val_2_5").prop("checked", false);
          $("#osen_info").find("input#osen_val_4").prop("checked", false);
          $("#osen_info").find("input#osen_val_1").prop("disabled", true);
          $("#osen_info").find("input#osen_val_2_5").prop("disabled", true);
          $("#osen_info").find("input#osen_val_4").prop("disabled", true);
          $("#osen_or_schlauf_info").find("input[name='length_bar']").prop("disabled", true);
          $("#Gleiter_info").find("input#halbverdeckter").prop("disabled", true);

    /* Schlaufen */
    } else if ($(this).attr("value") == '190') {
          $("#osen_info").hide();
          $("#clic_info").hide();
          $("#click_or_wave_info").hide();
          $("#wave_info").hide();
          $("#osen_or_schlauf_info").show();
          $('#length').val('');
          $('#length_wave').val('');
          $("#Gleiter_info").hide();

          $("#clic_info").find("input[name='minMax']").prop("disabled", true);
          $("#osen_info").find("input#osen_val_1").prop("checked", false);
          $("#osen_info").find("input#osen_val_2_5").prop("checked", false);
          $("#osen_info").find("input#osen_val_4").prop("checked", false);
          $("#osen_info").find("input#osen_val_1").prop("disabled", true);
          $("#osen_info").find("input#osen_val_2_5").prop("disabled", true);
          $("#osen_info").find("input#osen_val_4").prop("disabled", true);
          $("#click_or_wave_info").find("input[name='length']").prop("disabled", true);
          $("#wave_info").find("select[name='length_wave']").prop("disabled", true);
          $("#osen_or_schlauf_info").find("input[name='length_bar']").prop("disabled", false);
          $("#Gleiter_info").find("input#halbverdeckter").prop("disabled", true);
      }
  });

  $(".quantityPrice .control").on('click change keyUp', function(e) {
      if ($('#length_bar').val() != '') {
          if ($('#length_bar').length === 0) {
              if (inventory.inventory_policy === 'deny' && $('.quantityPrice input.quantity-input.quantity-element').val() >= inventory.inventory_quantity) {
                  e.preventDefault();
                  $('[data-update-quantity="plus"]').attr('disabled', 'disabled');
              }
          }
      }

      if ($('#length').val() != '') {
          if ($('#length').length === 0) {
              if (inventory.inventory_policy === 'deny' && $('.quantityPrice input.quantity-input.quantity-element').val() >= inventory.inventory_quantity) {
                  e.preventDefault();
                  $('[data-update-quantity="plus"]').attr('disabled', 'disabled');
              }
          }
      }

      if ($('#length_wave').val() != '') {
          if ($('#length_wave').length === 0) {
              if (inventory.inventory_policy === 'deny' && $('.quantityPrice input.quantity-input.quantity-element').val() >= inventory.inventory_quantity) {
                  e.preventDefault();
                  $('[data-update-quantity="plus"]').attr('disabled', 'disabled');
              }
          }
      }


      setTimeout(function() {
          // Get the unit price from data-price attribute (which stores price for 1 unit)
          var pricePerUnit = parseFloat($('.purchase-details .price .money').attr('data-price')) || currentPrice();
          var comparePricePerUnit = parseFloat($('.purchase-details .compare-at-price .money').attr('data-price')) || currentComparePrice();

          var newPrice = pricePerUnit * currentQuantity();
          var newComparePrice = comparePricePerUnit * currentQuantity();

          $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(newPrice, 2, '.', ''));
          $('.purchase-details .modal_price .compare-at-price .money').text('CHF ' + numberFormat(newComparePrice, 2, '.', ''));
          $('.heidipay_inline_monthly_amount').text('CHF ' + numberFormat((pricePerUnit / parseInt($('.heidipay_inline').text().replace(/^\D+/g, ''))), 2, '.', ''));
          previousQuantity = currentQuantity();
          updateSalePercentage();
      }, 300);

  })

  var new_product_price = 0;
  var verkauft_als_stoff = 'nein';

  var stoffmenge = 0;

  var buy_custom_curtain = $('button.custom_height_curtain, button.custom_width_curtain');


  setTimeout(() => {
      if (buy_custom_curtain.length) {
          buy_custom_curtain.attr('disabled', 'disabled');
      }
  }, 500);



  $("#length_bar, #length_wave, #height, #length, #location, input[name='accesories'], #osen_val_1, #osen_val_2_5, #osen_val_4, input[name='set'], input[name='minMax'], input[name='second_gleiter']").on('keyup change', function() {
      var width_value;

      /* length_wave is a dropdown and always has a value. Therefore it must be displayed first */
      if ($('#length_wave').val() != '') {
          width_value = $('#length_wave').val();
      }

      if ($('#length_bar').val() != '') {
          width_value = $('#length_bar').val();
      }

      if ($('#length').val() != '') {
          width_value = $('#length').val();
      }


      var buy_custom_curtain = $('button.custom_height_curtain, button.custom_width_curtain');
      var height_value = $('#height').val();
      var curtain_set_pair = $('#pair').is(":checked");
      var curtain_set_piece = $('#piece').is(":checked");
      var curtain_set_clic = $('#clic').is(":checked");
      var curtain_set_osen = $('#osen').is(":checked");
      var curtain_set_schlaufen = $('#schlaufen').is(":checked");
      var curtain_set_wave = $('#wave').is(":checked");
      var curtain_set_maxi = $('#maxi').is(":checked");
      var curtain_set_mini = $('#mini').is(":checked");
      var curtain_set_verdeckter = $('#verdeckter').is(":checked");
      var curtain_set_halbverdeckter = $('#halbverdeckter').is(":checked");
      var height_tag = $('[data-height-tag]').data('height-tag') ? parseInt($('[data-height-tag]').data('height-tag').split(':')[1]) : 1;
      var width_tag = $('[data-width-tag]').data('width-tag') ? parseInt($('[data-width-tag]').data('width-tag').split(':')[1]) : 1;
      var rapport = $('[data-rapport]').length ? $('[data-rapport]').data('rapport') : 30;
      var calc_type = $('[data-calculator]').data('calculator');
      var osen = $('#osen_info input:checked').val();

      if (height_tag !== 1) {
          if (height_value > height_tag) {
              $('#height').addClass('val-invalid').val(height_tag);
              setTimeout(() => {
                  $('#height').removeClass('val-invalid');
              }, 500);
              return;
          }
      }

      /* Check if any options are unselected and disable add to cart button (buy_custom_curtain) */
      if (width_value == 0 || width_value == null || width_value == undefined || width_value == "") {
          $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(originalPrice * currentQuantity(), 2, '.', ''));
          $('.purchase-details .modal_price .compare-at-price .money').text('CHF ' + numberFormat(originalComparePrice * currentQuantity(), 2, '.', ''));
          $('.heidipay_inline_monthly_amount').text('CHF ' + numberFormat((currentPrice() / parseInt($('.heidipay_inline').text().replace(/^\D+/g, ''))), 2, '.', ''));
          updateSalePercentage();

          if (buy_custom_curtain.length) {
              buy_custom_curtain.attr('disabled', 'disabled');
          }
      } else if (calc_type !== 'default' && (height_value == 0 || height_value == null || height_value == undefined || height_value == "" || height_value == 0)) {
          $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(originalPrice * currentQuantity(), 2, '.', ''));
          $('.purchase-details .modal_price .compare-at-price .money').text('CHF ' + numberFormat(originalComparePrice * currentQuantity(), 2, '.', ''));
          $('.heidipay_inline_monthly_amount').text('CHF ' + numberFormat((currentPrice() / parseInt($('.heidipay_inline').text().replace(/^\D+/g, ''))), 2, '.', ''));
          updateSalePercentage();

          if (buy_custom_curtain.length) {
              buy_custom_curtain.attr('disabled', 'disabled');
          }
      } else if (curtain_set_pair == false && curtain_set_piece == false) {
          if (buy_custom_curtain.length) {
              buy_custom_curtain.attr('disabled', 'disabled');
          }
    
      } else if (curtain_set_verdeckter == false && curtain_set_halbverdeckter == false && $("#Gleiter_info").find("input[name='second_gleiter']").prop('disabled') == false) {
            if (buy_custom_curtain.length) {
                buy_custom_curtain.attr('disabled', 'disabled');
            }
      } else if (curtain_set_clic == false && curtain_set_osen == false && curtain_set_schlaufen == false && curtain_set_wave == false) {
          if (buy_custom_curtain.length) {
              buy_custom_curtain.attr('disabled', 'disabled');
          }
      } else if (curtain_set_clic == true && curtain_set_mini == false && curtain_set_maxi == false) {
          if (buy_custom_curtain.length) {
              buy_custom_curtain.attr('disabled', 'disabled');
          }
      } else if (curtain_set_wave == true && curtain_set_mini == false && curtain_set_maxi == false) {
            if (buy_custom_curtain.length) {
                buy_custom_curtain.attr('disabled', 'disabled');
            }
      } else {
          $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(originalPrice * currentQuantity(), 2, '.', ''));
          $('.purchase-details .modal_price .compare-at-price .money').text('CHF ' + numberFormat(originalComparePrice * currentQuantity(), 2, '.', ''));
          $('.heidipay_inline_monthly_amount').text('CHF ' + numberFormat((currentPrice() / parseInt($('.heidipay_inline').text().replace(/^\D+/g, ''))), 2, '.', ''));
          updateSalePercentage();

          buy_custom_curtain.removeAttr('disabled');

          var width = parseInt(width_value);
          var height = parseInt(height_value);
          var n_width = width / 100;
          var width_price = 0;
          var compare_width_price = 0;
          var new_height = 1;

          // Define curtain_factor
          var shop_domain = window.PXUTheme.theme_settings.domain;
          if(shop_domain == 'vorhangschweiz.ch') {
            var curtain_factor = 1.8;
          } else {
            var curtain_factor = 1.5;
          }

          /* Set special factor for Schlaufen/ */
          if(curtain_set_osen || curtain_set_schlaufen) {
            curtain_factor = 1.25;
          } else if (curtain_set_wave || curtain_set_clic) {
            if(shop_domain == 'vorhangschweiz.ch') {
                curtain_factor = 1.8;
            } else {
                curtain_factor = 1.5;
            }
          }

          if (calc_type === 'default') { /* Type Default */
              stoffmenge = (width * curtain_factor);
              width_price = roundUp((((width * curtain_factor)) / 100), 1);
              compare_width_price = roundUp((((width * curtain_factor)) / 100), 1);

              // Final price for the width of curtain
              width_price = (width_price * parseFloat(originalPrice)).toFixed(2);
              compare_width_price = (compare_width_price * parseFloat(originalComparePrice)).toFixed(2);

          } else { /* Type Africa */
              var width_price_rounded = Math.max(Math.round((width * curtain_factor) / width_tag), 1);
              new_height = Math.ceil((height + rapport) / 10) * 10;
              stoffmenge = width_price_rounded * new_height;

              // Final price for the width of curtain
              width_price = (((width_price_rounded * new_height) * parseFloat(originalPrice)) / 100).toFixed(2);
              compare_width_price = (((width_price_rounded * new_height) * parseFloat(originalComparePrice)) / 100).toFixed(2);
          }

          $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(width_price * currentQuantity(), 2, '.', '')).attr('data-price', width_price);
          $('.purchase-details .modal_price .compare-at-price .money').text('CHF ' + numberFormat(compare_width_price * currentQuantity(), 2, '.', '')).attr('data-price', compare_width_price);
          $('.heidipay_inline_monthly_amount').text('CHF ' + numberFormat((currentPrice() / parseInt($('.heidipay_inline').text().replace(/^\D+/g, ''))), 2, '.', ''));
          updateSalePercentage();

          new_product_price = numberFormat(width_price, 2, '.', '');

          var accesories_price = $('input[name="accesories"]:checked').val();

          if (accesories_price === undefined || accesories_price === "undefined" || typeof accesories_price === undefined || typeof accesories_price === "undefined") {

          } else {
            var accesories_is_clic = $('input[id="clic"]:checked').val();
            if (accesories_is_clic) {
                if(height_tag > width_tag) {
                    var accesories_price = n_width * 60;
                } else {
                    var accesories_price = n_width * 90;
                }
            } else {
                var accesories = parseInt(accesories_price);
                var accesories_price = n_width * accesories;

            }

            var final_price = parseFloat(width_price) + parseFloat(accesories_price);
            var compare_final_price = parseFloat(compare_width_price) + parseFloat(accesories_price);

            $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(final_price * currentQuantity(), 2, '.', '')).attr('data-price', final_price);
            $('.purchase-details .modal_price .compare-at-price .money').text('CHF ' + numberFormat(compare_final_price * currentQuantity(), 2, '.', '')).attr('data-price', compare_final_price);
            $('.heidipay_inline_monthly_amount').text('CHF ' + numberFormat((currentPrice() / parseInt($('.heidipay_inline').text().replace(/^\D+/g, ''))), 2, '.', ''));
            updateSalePercentage();

            new_product_price = numberFormat(final_price, 2, '.', '');
          }
      }
  });


  // Sell fabric calculator

  var fabric_price = currentPrice() / currentQuantity();
  console.log('fabric_price: ' + fabric_price);
  var compare_fabric_price = currentComparePrice() / currentQuantity();
  var origin_price = [];
  origin_price.push(fabric_price);
  var fabric_price_custom_price = 0;

  if ($('[data-calc="Africa-fabric"]').length) {
      var isMass = $('[data-calc="Africa-fabric"]').attr('data-hidden');
  } else {
      var isMass = $('[data-calc="Default-fabric"]').attr('data-hidden');
  }

  if (isMass === '') {
      isMass = true;
  } else {
      isMass = false;
  }

  $('#configurator-fabric').on('click', function(e) {
      var buy_custom_curtain = $('button.custom_height_curtain, button.custom_width_curtain');
      var sell_as_fabric_text = $(this).find('> span');

      previousQuantity = 1;
      $(".quantityPrice .quantity-input").val(1);

      $('.custom-opitons_wrap input[type="number"]').each(function() {
          $(this).val('');
      });


      $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(originalPrice * currentQuantity(), 2, '.', ''));
      $('.purchase-details .modal_price .compare-at-price .money').text('CHF ' + numberFormat(originalComparePrice * currentQuantity(), 2, '.', ''));
      $('.heidipay_inline_monthly_amount').text('CHF ' + numberFormat((currentPrice() / parseInt($('.heidipay_inline').text().replace(/^\D+/g, ''))), 2, '.', ''));


      if (sell_as_fabric_text.text() == 'Dieser Artikel kann auch als Einzelstoff bezogen werden.') {
          sell_as_fabric_text.text('Dieser Artikel kann auch als massgeschneiderter Vorhang bezogen werden.');
          verkauft_als_stoff = 'ja';
          if (inventory.inventory_policy === 'continue' && inventory.inventory_quantity <= 0) {
              $('[data-lieferzeit]').text("3 - 6 Wochen");
          } else {
              $('[data-lieferzeit]').text($('[data-lieferzeit]').data('lagerort'));
          }
      } else if (sell_as_fabric_text.text() == 'Dieser Artikel kann auch als massgeschneiderter Vorhang bezogen werden.') {
          sell_as_fabric_text.text('Dieser Artikel kann auch als Einzelstoff bezogen werden.');
          verkauft_als_stoff = 'nein';
          if (inventory.inventory_policy === 'continue' && inventory.inventory_quantity <= 0) {
              $('[data-lieferzeit]').text("3 - 6 Wochen");
          } else {
              $('[data-lieferzeit]').text($('[data-lieferzeit]').data('masslagerort'));
          }
          $("#width-fabric").val('');
          $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(origin_price[0] * currentQuantity(), 2, '.', ''));
          $('.purchase-details .modal_price .compate-at-price .money').text('CHF ' + numberFormat(compare_fabric_price * currentQuantity(), 2, '.', ''));
          $('.heidipay_inline_monthly_amount').text('CHF ' + numberFormat((currentPrice() / parseInt($('.heidipay_inline').text().replace(/^\D+/g, ''))), 2, '.', ''));

      }

      if (verkauft_als_stoff == 'nein') {
          $('.product-type').text('Vorhang nach Mass');
      } else {
          $('.product-type').text('Stoff');
      }

      buy_custom_curtain.attr('disabled', 'disabled');

      var type = $(this).data('type');

      if (type === 'Africa') {
          if ($('[data-calculator="Africa"]').attr('data-hidden') == '') {
              $('[data-calculator="Africa"]').removeAttr('data-hidden');
              $('[data-calc="Africa-fabric"]').attr('data-hidden', 'hidden');
              isMass = true;
          } else {
              $('[data-calculator="Africa"]').attr('data-hidden', '');
              $('[data-calc="Africa-fabric"]').removeAttr('data-hidden');
              isMass = false;
          }
      } else if (type === 'Default') {
          if ($('[data-calculator="default"]').attr('data-hidden') == '') {
              $('[data-calculator="default"]').removeAttr('data-hidden');
              $('[data-calc="Default-fabric"]').attr('data-hidden', '');
              isMass = true;
          } else {
              $('[data-calculator="default"]').attr('data-hidden', '');
              $('[data-calc="Default-fabric"]').removeAttr('data-hidden');
              isMass = false;
          }
      }
  });



  $("#width-fabric").on('keyup change', function() {

      var buy_custom_curtain = $('button.custom_height_curtain, button.custom_width_curtain');
      var width = parseInt($('#width-fabric').val());

      verkauft_als_stoff = 'ja';
      fabric_price_custom_price = (origin_price[0] * width) / 100;
      compare_fabric_price_custom_price = (compare_fabric_price * width) / 100;
      if (width == 0 || width == null || width == undefined || width == "" || isNaN(width)) {
          $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(origin_price[0] * currentQuantity(), 2, '.', ''));
          $('.purchase-details .modal_price .compare-at-price .money').text('CHF ' + numberFormat(compare_fabric_price * currentQuantity(), 2, '.', ''));
          buy_custom_curtain.attr('disabled', 'disabled');
      } else {
          $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(fabric_price_custom_price * currentQuantity(), 2, '.', ''));
          $('.purchase-details .modal_price .compare-at-price .money').text('CHF ' + numberFormat(compare_fabric_price_custom_price * currentQuantity(), 2, '.', ''));
          buy_custom_curtain.removeAttr('disabled');
      }
      $('.heidipay_inline_monthly_amount').text('CHF ' + numberFormat((currentPrice() / parseInt($('.heidipay_inline').text().replace(/^\D+/g, ''))), 2, '.', ''));

  });

  if (buy_custom_curtain.length) {
      buy_custom_curtain.on('click', function(event) {
          event.preventDefault();
          event.stopPropagation();

          if (!buy_custom_curtain.hasClass('disabled')) {
              var pid = $('[data-product-id]').data('product-id');
              var price = new_product_price;
              
              if ($('#length_bar').val() != '') {
                  var width_value = $('#length_bar').val();
              }
              if ($('#length').val() != '') {
                  var width_value = $('#length').val();
              }
              /* Schienenlänge in cm (dropdown) */
              if ($('#length_wave').val() != null) {
                var width_value = $('#length_wave').val();
              }

              var height_value = $('#height').val();

              if (verkauft_als_stoff == 'ja') {
                  width_value = $('#width-fabric').val();
                  console.log('width_value: ' + width_value);
                  price = fabric_price_custom_price;
                  console.log('price: ' + price);
              } else {
                  price = new_product_price;
              }
              console.log('new_product_price: ' + new_product_price);

              var inventory = JSON.parse($('[data-product-form]').attr('data-variant-inventory').replace('[', '').replace(']', ''));

              if ((width_value && width_value < 20) || (height_value && height_value < 20)) {
                  var warning = '';
                  if ($('[data-height-tag]').data('height-tag') && height_value && height_value < 20) {
                      warning = `<p class="cart-warning__message animated bounceIn">Bitte geben Sie einen Wert zwischen 20 cm und ${ parseInt($('[data-height-tag]').data('height-tag').split(':')[1]) } cm ein</p>`;
                  } else {
                      warning = `<p class="cart-warning__message animated bounceIn">Bitte geben Sie einen Wert grösser als 20 cm ein</p>`;
                  }

                  $('.warning').remove();

                  $('[data-product-form]')
                      .find('.cart-warning')
                      .html(warning);

                  buy_custom_curtain
                      .removeAttr('disabled')
                      .removeClass('disabled');

                  buy_custom_curtain.find('.icon')
                      .removeClass('zoomOut')
                      .addClass('zoomIn');

                  buy_custom_curtain
                      .find('span:not(.icon)')
                      .text(buy_custom_curtain.data('label'))
                      .removeClass('zoomOut')
                      .addClass('zoomIn');
              } else {
                  var width_value_stoff = 0;
                  if ($('[data-calc]').data('hidden') == 'hidden') {
                      var rapport = $('[data-rapport]').length ? $('[data-rapport]').data('rapport') : 30;
                      var width_tag = $('[data-width-tag]').data('width-tag') ? parseInt($('[data-width-tag]').data('width-tag').split(':')[1]) : 1;
                      var width_price_rounded = Math.round((width_value * curtain_factor) / width_tag);
                      console.log('test lower part curtain_factor: ' + curtain_factor);
                      var new_height = Math.ceil((parseInt(height_value) + rapport) / 10) * 10;
                      width_value_stoff = width_price_rounded * new_height;
                  } else {
                      width_value_stoff = width_value;
                  }
                  
                  if (inventory.inventory_policy === 'deny' && (($('.quantityPrice input.quantity-input.quantity-element').val() * width_value_stoff) / 100) > inventory.inventory_quantity) {
                      const cartWarning = `<p class="cart-warning__message animated bounceIn">Der gewünschte Artikel ist in der gewünschten Menge leider nicht mehr bestellbar (maximal verfügbare Menge ${ inventory.inventory_quantity * 100 } cm)</p>`;

                      $('.warning').remove();

                      $('[data-product-form]')
                          .find('.cart-warning')
                          .html(cartWarning);

                      buy_custom_curtain
                          .removeAttr('disabled')
                          .removeClass('disabled');

                      buy_custom_curtain.find('.icon')
                          .removeClass('zoomOut')
                          .addClass('zoomIn');

                      buy_custom_curtain
                          .find('span:not(.icon)')
                          .text(buy_custom_curtain.data('label'))
                          .removeClass('zoomOut')
                          .addClass('zoomIn');
                  } else {
                      $('.cart-warning__message').remove();
                      $('[data-add-to-cart-trigger]').addClass('disabled');
                      $('.fabric-sample > button').addClass('disabled');
                      $('[data-add-to-cart-trigger] i, [data-add-to-cart-trigger] span').addClass('zoomOut');
                      $('[data-add-to-cart-trigger]').addClass('button_loading');

                      var stoffmenge_just_fabric_size = $('#width-fabric');


                      if (stoffmenge_just_fabric_size !== undefined || stoffmenge_just_fabric_size !== "undefined" || typeof stoffmenge_just_fabric_size !== undefined || typeof stoffmenge_just_fabric_size !== "undefined") {
                          if (stoffmenge_just_fabric_size.val()) {
                              stoffmenge = stoffmenge_just_fabric_size.val();
                          }
                      }

                      /* Check if inputs are disabled. Returns undefined if input is not disabled */
                      let gleiter = $("#clic_info").find("input[name='minMax']").prop('disabled');
                      let second_gleiter = $("#Gleiter_info").find("input[name='second_gleiter']").prop('disabled');

                      let stangen = $('#osen_info input:checked').val();
                      let Verdunklungsgrad = $("#Verdunklungsgrad").val();
                      let Abschluss = $("#Abschluss").val();
                      let Transparenz = $("#Transparenz").val();

                      let productData = {};
                      if ($('#length_bar').val() != '') {
                          productData = {
                              pid: pid,
                              price: price,
                              isMass: isMass,
                              title: $('.vs-product-title').text().trim(),
                              StangenLange: width_value,
                              Länge: height_value,
                              Vorhangschnitt: $('input[name="set"]:checked').length > 0 ? $('input[name="set"]:checked').attr('data-type') : 0,
                              Aufhängung: $('input[name="accesories"]:checked').length > 0 ? $('input[name="accesories"]:checked').attr('data-type') : 0
                          }
                      }
                      if ($('#length').val() != '' || $('#length_wave').val() != '') {
                          productData = {
                              pid: pid,
                              price: price,
                              isMass: isMass,
                              title: $('.vs-product-title').text().trim(),
                              SchienLange: width_value,
                              Länge: height_value,
                              Vorhangschnitt: $('input[name="set"]:checked').length > 0 ? $('input[name="set"]:checked').attr('data-type') : 0,
                              Aufhängung: $('input[name="accesories"]:checked').length > 0 ? $('input[name="accesories"]:checked').attr('data-type') : 0
                          }
                      }


                      /* Add info to productData array if input field is not disabled (undefined) */
                      if (!gleiter) {
                          productData['Gleiter'] = $('input[name="minMax"]:checked').length > 0 ? $('input[name="minMax"]:checked').attr('data-type') : 0
                      }
                      if (!second_gleiter) {
                          productData['AbschlussOben'] = $('input[name="second_gleiter"]:checked').length > 0 ? $('input[name="second_gleiter"]:checked').attr('data-type') : 0
                      }
                      if (stangen) {
                          productData['Ösengrösse'] = $('#osen_info input:checked').val() + ' cm';
                      }


                      if ($('#Verdunklungsgrad').val() != '') {
                          productData['Verdunklungsgrad'] = $('#Verdunklungsgrad').val();
                      }
                      if ($('#Abschluss').val() != '') {
                          productData['AbschlussUnten'] = $('#Abschluss').val();
                      }
                      if ($('#Transparenz').val() != '') {
                          productData['Transparenz'] = $('#Transparenz').val();
                      }

                      productData['pid'] = pid;
                      productData['price'] = price;
                      productData['Stoffmenge'] = stoffmenge
                      productData['original_product_url'] = window.location.href
                      if ($('#location').val() != '') {
                        productData['Aufhängeort'] = $('#location').val();
                      }
                      console.log(productData);
                      var shop_domain = window.PXUTheme.theme_settings.domain;
                      var api_url = 'https://apps.vorhangschweiz.ch/functions/duplicate.cfm';
                    
                      $.ajax({
                          type: "POST",
                          data: JSON.stringify(productData),
                          contentType: "application/json",
                          dataType: "json",
                          headers: {
                            'x-shopify-shop': shop_domain
                          },
                          url: api_url,
                          always: function(data) {
                              console.log(data);
                          },
                          success: function(data) {

                              if (data.success === true) {
                                  $.ajax({
                                      type: 'POST',
                                      url: '/cart/add.js',
                                      data: {
                                          items: [{
                                              id: data.vid,
                                              quantity: $('.quantityPrice input.quantity-input.quantity-element').val(),
                                              properties: {}
                                          }]
                                      },
                                      dataType: 'json',
                                      success: function(data) {
                                          $('[data-add-to-cart-trigger]').removeClass('button_loading');
                                          $('[data-add-to-cart-trigger] svg.checkmark').addClass('checkmark-active');
                                          window.PXUTheme.jsAjaxCart.updateView();
                                          setTimeout(function() {
                                              $('[data-add-to-cart-trigger] i, [data-add-to-cart-trigger] span').hide();
                                          }, 300);
                                          setTimeout(function() {
                                              $('.header-cart.action-area__link').addClass('show-mini-cart');
                                              $('[data-add-to-cart-trigger]').removeClass('disabled');
                                              $('.fabric-sample > button').removeClass('disabled');
                                              $('[data-add-to-cart-trigger] i, [data-add-to-cart-trigger] span').removeClass('zoomOut');
                                              $('[data-add-to-cart-trigger] i, [data-add-to-cart-trigger] span').show();
                                              $('[data-add-to-cart-trigger] svg.checkmark').removeClass('checkmark-active');
                                          }, 2000);
                                      },
                                      error: function(data, textstatus) {
                                          console.log(data);
                                          // alert(data.responseJSON.message + '. ' + data.responseJSON.description);
                                          // alert("Something went wrong. Please try again. Contact us if it doesn't help.");
                                      },
                                  });
                              }
                          },
                          error: function(data) {
                              console.log(data);
                          }
                      });
                  }
              }
          }
      });
  }

  // Sample product
  // 
  $('.fabric-sample > button').on('click', function(e) {

      e.preventDefault();
      e.stopPropagation();

      if (!$('.fabric-sample > button').hasClass('disabled')) {

          $('.fabric-sample > button').addClass('disabled');
          $('[data-add-to-cart-trigger]').addClass('disabled');
          $('.fabric-sample > button i, .fabric-sample > button span').addClass('zoomOut');
          $('.fabric-sample > button').addClass('button_loading');

          var pid = $('[data-product-id]').data('product-id');
          var shop_domain = window.PXUTheme.theme_settings.domain;
          var api_url_sample = 'https://apps.vorhangschweiz.ch/functions/sample.cfm';

          $.ajax({
              type: "POST",
              data: JSON.stringify({
                  pid: pid,
                  title: $('.vs-product-title').text().trim(),
                  original_product_url: window.location.href
              }),
              contentType: "application/json",
              dataType: "json",
              headers: {
                'x-shopify-shop': shop_domain
              },
              url: api_url_sample,
              always: function(data) {
                  console.log(data);
              },
              success: function(data) {
                  console.log(data);
                  if (data.success === true) {

                      $.ajax({
                          type: 'POST',
                          url: '/cart/add.js',
                          data: {
                              items: [{
                                  id: data.vid,
                                  quantity: $('input.quantity-input.quantity-element').val(),
                                  properties: {}
                              }]
                          },
                          dataType: 'json',
                          success: function(data) {
                              $('.fabric-sample > button').removeClass('button_loading');
                              $('.fabric-sample > button').addClass('checkmark-animation');
                              $('.fabric-sample > button svg').addClass('checkmark-active');
                              window.PXUTheme.jsAjaxCart.updateView();
                              setTimeout(function() {
                                  $('.fabric-sample > button').removeClass('checkmark-animation');
                                  $('.fabric-sample > button svg').removeClass('checkmark-active');
                                  $('.fabric-sample > button').removeClass('disabled');
                                  buy_custom_curtain.removeClass('disabled');
                                  $('.fabric-sample > button span').removeClass('zoomOut');
                                  $('.fabric-sample > button span').show();
                              }, 2000);
                          },
                          error: function(data, textstatus) {
                              console.log(data);
                              // alert(data.responseJSON.message + '. ' + data.responseJSON.description);
                              // alert("Something went wrong. Please try again. Contact us if it doesn't help.");
                          },
                      });
                  }
              },
              error: function(data) {
                  console.log(data);
              }
          });

      }
  })
});
